<template>
  <GrayBlockContainer>
    <p class="section-title">發票資訊</p>
    <BaseElFormItem label="選擇發票類型" prop="invoice.type">
      <BaseElSelect v-model="context.invoice.type">
        <BaseElSelectOption
          v-for="option in displayInvoiceTypeOptions"
          :key="option.value"
          :value="option.value"
          :label="option.label"
        />
      </BaseElSelect>
    </BaseElFormItem>

    <div v-if="showControl.B2BInfo">
      <BaseElFormItem label="公司行號抬頭" prop="invoice.companyTitle">
        <BaseElInput v-model="context.invoice.companyTitle" placeholder="請輸入公司行號抬頭" clearable />
      </BaseElFormItem>
      <BaseElFormItem label="統一編號" prop="invoice.taxId">
        <BaseElInput v-model="context.invoice.taxId" placeholder="請輸入統一編號" clearable />
      </BaseElFormItem>
    </div>

    <template v-if="context.invoice.type === 'carrier'">
      <BaseElFormItem label="載具類型" prop="invoice.carrierType">
        <BaseElSelect v-model="context.invoice.carrierType" placeholder="請選擇載具類型">
          <BaseElSelectOption
            v-for="option in carrierTypeOptions"
            :key="option.value"
            :value="option.value"
            :label="option.label"
          />
        </BaseElSelect>
      </BaseElFormItem>
      <BaseElFormItem label="載具號碼" prop="invoice.carrierNum">
        <BaseElInput
          v-model="context.invoice.carrierNum"
          :placeholder="carrierNumPlaceholder"
          clearable
        />
      </BaseElFormItem>
    </template>

    <BaseElFormItem label="電子信箱" prop="invoice.email">
      <BaseElInput v-model="context.invoice.email" type="email" name="email" placeholder="請輸入Email" clearable />
    </BaseElFormItem>
  </GrayBlockContainer>
</template>

<script>
import GrayBlockContainer from '@/components/Container/GrayBlockContainer.vue'
import { invoiceTypeWithCarrierList } from '@/config/invoice'
import { useInvoiceCarrier } from '@/use/useInvoiceCarrier'
import { useCreateAppointment } from '@/use/useCreateAppointment'
import { get } from 'lodash'
import { computed, defineComponent, onMounted, watch } from 'vue'

export default defineComponent({
  name: 'AppointmentInvoiceInfoBlock',
  components: {
    GrayBlockContainer,
  },
  setup () {
    const { context } = useCreateAppointment()
    const { carrierTypeOptions, getCarrierNumPlaceholder } = useInvoiceCarrier('appointmentCheckout')
    const showControl = computed(() => {
      const controls = {
        B2BInfo: false,
      }
      if (context.invoice.type === 'B') {
        controls.B2BInfo = true
      }
      return controls
    })

    const displayInvoiceTypeOptions = invoiceTypeWithCarrierList

    const carrierNumPlaceholder = computed(() => {
      return getCarrierNumPlaceholder(context.invoice.carrierType)
    })

    const applyMemberDefaults = (member) => {
      if (!member) return
      context.invoice.email = get(member, 'UserInfo.email')
      const defaultCarrierType = get(member, 'UserInfo.defaultCarrierType')
      const defaultCarrierNum = get(member, 'UserInfo.defaultCarrierNum') || null
      if (defaultCarrierType) {
        context.invoice.type = 'carrier'
        context.invoice.carrierType = defaultCarrierType
        context.invoice.carrierNum = defaultCarrierNum
      }
    }

    onMounted(() => {
      applyMemberDefaults(context.member)
    })

    watch(() => context.member, (member) => {
      applyMemberDefaults(member)
    })

    watch(() => context.invoice.type, (type) => {
      if (type !== 'B') {
        context.invoice.companyTitle = null
        context.invoice.taxId = null
      }

      if (type !== 'carrier') {
        context.invoice.carrierType = null
        context.invoice.carrierNum = null
      }
    })

    return {
      context,
      showControl,
      displayInvoiceTypeOptions,
      carrierNumPlaceholder,
      carrierTypeOptions,
    }
  },
})

</script>

<style scoped lang="postcss">
.section-title {
  @apply font-bold text-primary-100 text-[18px] mb-[24px];
}
</style>
